import { AimOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { PerformanceReportDataSourceEnum } from "types/enums.ts";

interface ReportSourceToggleButtonProps {
    actualSource: PerformanceReportDataSourceEnum;
    onToggle: () => void;
}

export const ReportSourceToggleButton = ({ actualSource, onToggle }: ReportSourceToggleButtonProps) => {
    const { t } = usePaldockTranslation("common");
    const isActive = actualSource === PerformanceReportDataSourceEnum.ReportPerformances;

    return (
        <Button
            type="link"
            size="small"
            onClick={onToggle}
            aria-label={t("report_source_toggle.aria_label")}
            aria-pressed={isActive}
            style={{ color: isActive ? "#1677ff" : "#000000" }}
            icon={<AimOutlined />}
        />
    );
};
